import { BaseAddress } from "../../config";
import performRequest from "../../utils/requestHelpers";
import { getMeta, getDashboard } from "./mockServer";

const USE_MOCK = false;

// Здоровье живёт под префиксом CcAdmin (/api/scadmin), а не Api (/api/kulsary)
const BASE = BaseAddress.CcAdmin;

const withAuth = (option) => {
  const token = localStorage.getItem("token");
  return token
    ? {
        ...option,
        headers: {
          ...(option && option.headers),
          Authorization: "Bearer " + token,
        },
      }
    : option;
};

const delay = (data, ms = 300) =>
  new Promise((resolve) => setTimeout(() => resolve(data), ms));

export const fetchMeta = () => {
  if (USE_MOCK) return delay(getMeta(), 150);
  return performRequest(`${BASE}/api/health/meta`, withAuth());
};

export const fetchDashboard = ({ type, report, from, to }) => {
  if (USE_MOCK) return delay(getDashboard({ type, report, from, to }));
  const qs = `type=${type}&report=${encodeURIComponent(
    report
  )}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
  return performRequest(`${BASE}/api/health/dashboard?${qs}`, withAuth());
};
